import React from 'react';
import {connect} from 'react-redux';
import {routeNodeSelector} from 'redux-router5';
import ErrorDisplay from './ErrorDisplay';

const ErrorPage = ({route}) => {
  return <ErrorDisplay error={route.params.error} title={route.params.title} />;
};

const mapStateToProps = state => ({
  ...routeNodeSelector('error')(state),
});

export default connect(mapStateToProps)(ErrorPage);



// WEBPACK FOOTER //
// ./src/components/Common/Error/ErrorPage.js